/* eslint-disable no-console */
import { getClient, PollingMode } from 'configcat-js'
import { useQuery } from '@tanstack/react-query'
import { QUERY_DATA } from 'src/service'

const STALE_TIME_IN_MS = 30000

const CONFIG_CAT_KEY = process.env.REACT_APP_CONFIGCAT_KEY.toString()

const configCatClient = getClient(CONFIG_CAT_KEY, PollingMode.LazyLoad, {
  cacheTimeToLiveSeconds: Number(process.env.REACT_APP_CONFIGCAT_CACHE_TTL || 60),
})

export type FeatureFlagValue = string | boolean | number | undefined | null

export interface SettingKeyValue {
  settingKey: string
  settingValue: FeatureFlagValue
}

export const buildConfigCatObject = (keyValuePairs: SettingKeyValue[]) => {
  const configCatObject: Record<string, FeatureFlagValue> = {}

  keyValuePairs.forEach(({ settingKey, settingValue }) => {
    const isString = typeof settingValue === 'string'
    try {
      if (isString) {
        configCatObject[settingKey] = JSON.parse(settingValue)
      } else {
        configCatObject[settingKey] = settingValue
      }
    } catch (err) {
      configCatObject[settingKey] = settingValue
    }
  })

  return configCatObject
}

const fetchConfigCatValues = async () => {
  const result = await configCatClient.getAllValuesAsync()

  return buildConfigCatObject(result)
}

export const useConfigCat = () => {
  const {
    data = {},
    isLoading,
    isError,
  } = useQuery<Record<string, FeatureFlagValue>>([QUERY_DATA.CONFIG_CAT], fetchConfigCatValues, {
    staleTime: STALE_TIME_IN_MS,
    refetchOnWindowFocus: false,
  })

  return {
    featureFlags: data,
    isLoading,
    isError,
  }
}
